import { createFileRoute } from '@tanstack/react-router'
import { DashboardPage } from '../../../features/platform/dashboard-page'

export const Route = createFileRoute('/platform/_console/dashboard')({
  component: DashboardPage,
})
